import { typedQueryClient, useTypedMutation } from "hooks";
import { CheckInServicesQueryKeys } from "modules/CheckInServices/queryKeys";
import { ApiInstance } from "utils/Api";

import type { CheckInService } from "models";

export const useCreateCheckInServiceMutation = () =>
  useTypedMutation<CheckInService, number>({
    mutationFn: async payload => (await ApiInstance.post("/check_in/service/create", payload)).data.check_in_service_id,
    onSuccess: (payload, id) => {
      const services = typedQueryClient.getQueryData(CheckInServicesQueryKeys.dealerList);
      if (!services) return;

      typedQueryClient.setQueryData(CheckInServicesQueryKeys.dealerList, [...services, { ...payload, id }]);
    }
  });
